import { IconLock, IconPlayerPlay, IconSettings, IconShieldHalf } from "@tabler/icons-react";
import { Trans } from "@lingui/macro";

import { getAnalyticsAdapter } from "../../analytics/AnalyticsAdapter";
import { localeLabels, locales } from "../../i18n";
import { useGameStore } from "../../state/store";
import { useTutorialStore } from "../../state/tutorialStore";
import { Button } from "../common/Button";
import { cx } from "../common/cx";
import styles from "./MainMenuScreen.module.css";

export function MainMenuScreen(): JSX.Element {
  const newGame = useGameStore((state) => state.newGame);
  const continueGame = useGameStore((state) => state.continueGame);
  const navigateTo = useGameStore((state) => state.navigateTo);
  const language = useGameStore((state) => state.settings.language);
  const setLanguage = useGameStore((state) => state.setLanguage);
  const lastSaveTime = useGameStore((state) => state.lastSaveTime);
  const startTutorial = useTutorialStore((state) => state.start);
  const tutorialStatus = useTutorialStore((state) => state.status);

  const handleNewGame = (): void => {
    newGame();
    getAnalyticsAdapter().track("new_game_started");
    startTutorial();
  };

  const hasProgress = useGameStore(
    (state) =>
      state.player.completedContracts.length > 0 ||
      state.player.ownedTools.length > 0 ||
      state.player.achievements.length > 0 ||
      state.player.xp > 0,
  );
  const canContinue = hasProgress || tutorialStatus !== "not_started";
  const lastSaveLabel = lastSaveTime > 0 ? new Date(lastSaveTime).toLocaleString() : null;

  return (
    <div className={styles.menu}>
      <div className={styles.brand}>
        <IconShieldHalf size={48} className={styles.brandIcon} aria-hidden="true" />
        <h1 className={styles.title}>
          <Trans>BreachGuard Bureau</Trans>
        </h1>
        <p className={styles.tagline}>
          <Trans>Консоль агентства кибербезопасности</Trans>
        </p>
        <span className={styles.safety}>
          <IconLock size={13} aria-hidden="true" />
          <Trans>Только вымышленные компании и домены *.example</Trans>
        </span>
      </div>

      <div className={styles.actions}>
        <Button variant="primary" icon={<IconPlayerPlay size={18} />} onClick={handleNewGame}>
          <Trans>Новая игра</Trans>
        </Button>
        {canContinue && (
          <Button variant="secondary" onClick={() => continueGame()}>
            <Trans>Продолжить</Trans>
          </Button>
        )}
        <Button variant="ghost" icon={<IconSettings size={18} />} onClick={() => navigateTo("settings")}>
          <Trans>Настройки</Trans>
        </Button>
        {lastSaveLabel && (
          <span className={cx(styles.lastSave, "mono")}>
            <Trans>Последнее сохранение: {lastSaveLabel}</Trans>
          </span>
        )}
      </div>

      <div className={styles.footer}>
        <span className={styles.langTabs}>
          {locales.map((locale) => (
            <button
              key={locale}
              type="button"
              className={cx(styles.langTab, locale === language && styles.langActive)}
              aria-pressed={locale === language}
              onClick={() => setLanguage(locale)}
            >
              {localeLabels[locale]}
            </button>
          ))}
        </span>
        <span className={styles.defensive}>
          <IconLock size={12} aria-hidden="true" /> <Trans>Defensive-only · *.example</Trans>
        </span>
      </div>
    </div>
  );
}
